import { useDashboard } from '../../../context/DashboardContext';

const MONTH_NAMES = [
  '',
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember',
];

/**
 * OutlookBlock — "Blick nach vorn"
 *
 * State 0: Hint to add plants first
 * State A: No upcoming care, optional next relevant month, Pflegekalender link
 * State B/F: Upcoming care phases (F = high complexity, same outlook copy)
 */
const OutlookBlock = () => {
  const { carePhase, setDashboardTab } = useDashboard();
  const { state, nextRelevantMonth } = carePhase;

  return (
    <section className="bg-white rounded-xl shadow-sm p-6">
      <h2 className="text-base font-bold text-gray-900 mb-4">Blick nach vorn</h2>

      {state === '0' && (
        <p className="text-xs text-gray-500">
          Sobald du Pflanzen angelegt hast, siehst du hier, wann Pflegephasen beginnen.
        </p>
      )}

      {state === 'A' && (
        <div>
          <p className="text-[13px] text-gray-600">
            In den kommenden Wochen sind keine Pflegemaßnahmen notwendig.
          </p>
          <p className="text-[13px] text-gray-600 mt-1">
            Grünraum behält das für dich im Blick.
          </p>
          {nextRelevantMonth != null && (
            <p className="text-xs text-gray-500 mt-3">
              Nächster relevanter Zeitraum: {MONTH_NAMES[nextRelevantMonth]}
            </p>
          )}
          <button
            onClick={() => setDashboardTab('pflegekalender')}
            className="text-[13px] text-gray-500 hover:text-gray-600 mt-3 block"
          >
            Pflegekalender anzeigen →
          </button>
        </div>
      )}

      {(state === 'B' || state === 'F') && (
        <div>
          <p className="text-[13px] text-gray-600">
            In den kommenden Wochen beginnen neue Pflegephasen.
          </p>
          <p className="text-[13px] text-gray-600 mt-1">
            Grünraum behält das für dich im Blick.
          </p>
        </div>
      )}
    </section>
  );
};

export default OutlookBlock;
